import { ICoverage } from '@webapp/payments';
import { IRisk } from '@webapp/risks';
import { RiskInsurableTypes } from '@webapp/risks';

export type ClientPolicyStatus = 'ACTIVE' | 'INACTIVE' | 'EMISSION' | 'EXPIRED' | 'CANCELLED';

export const DEFAULT_CLIENT_POLICY_STATUSES: readonly ClientPolicyStatus[] = [
  'ACTIVE',
  'INACTIVE',
  'EMISSION',
];

export const ALL_CLIENT_POLICY_STATUSES: readonly ClientPolicyStatus[] = [
  ...DEFAULT_CLIENT_POLICY_STATUSES,
  'EXPIRED',
  'CANCELLED',
];

export interface IClientPolicyCoverage
  extends Pick<ICoverage, 'title' | 'description' | 'type' | 'items' | 'prices'> {
  pricingMode: string;
  endDate: string | null;
  startDate: string | null;
}

export type IClientPolicyRisk =
  Pick<IRisk, 'name' | 'tag' | 'status' | 'roles' | 'personTypes' | 'paymentMethods'>
  & { hasReferralCode: boolean };

export interface IClientPolicy {
  id: string;
  status: ClientPolicyStatus;
  currency: string;
  internalNumber: number;
  operationNumber: number;
  quoteId: string;
  quoteInternalNumber: number;
  startDate: string | null;
  endDate: string | null;
  daysInFavor: number;
  coverage: IClientPolicyCoverage;
  insurable: RiskInsurableTypes;
  risk: IClientPolicyRisk;
  activations: unknown[];
  activationId: string | null;
  additionalCoverage: IClientPolicy | null;
  availableCoverages: unknown[];
}
